import React, {Component} from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router';
import lang from '../../constants/Languages.js';
import {ReactHeight} from 'react-height';
import ReactDOM from 'react-dom';
import numberWithSpaces from '../../scripts/NumberWithSpaces.js';

//import img
import chevronDown from '../../assets/icons/chevron-down-light.svg';
import chevronUp from '../../assets/icons/chevron-up-light.svg';
import fieldRed from '../../assets/icons/field-red.svg';
import fieldGreen from '../../assets/icons/field-green.svg';
import fieldYellow from '../../assets/icons/field-yellow.svg';
import fieldViolet from '../../assets/icons/field-violet.svg';

//import components
import StrucutreListItem from './StrucutreListItem.js';
import StrucutreListItemSingle from './StrucutreListItemSingle.js';
import LoadingIndicator from '../LoadingIndicator.js';

class HeadingsStrucutreListItem extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isOpened: true
        };
    };

    componentDidMount() {
        const {getHeadingChildren, domainCode, children} = this.props;
        window.addEventListener("resize", this.updateHeight.bind(this));
        
        if (this.state.isOpened && !children) {
            getHeadingChildren(domainCode);
        }
    };

    componentDidUpdate(nextProps, nextState) {
      
    };

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateHeight.bind(this));
    };

    toggleOpened = () => {
        const {getHeadingChildren, domainCode, children} = this.props;

        if (!this.state.isOpened && !children) {
            getHeadingChildren(domainCode);
        }

        this.setState({isOpened: !this.state.isOpened});
    };

    setStructureListHeight = (height) => {
        if (height) {
            this.setState({structureHeight: height });
            return;
        }

        if (this.structureList) {
            this.setState({structureHeight: ReactDOM.findDOMNode(this.structureList).clientHeight });
            return;
        }
    };

    updateHeight = () => {
        this.setStructureListHeight();
    };

    getImgField = (label) => {
        switch (label) {
            case 'literature-theory':
                return <img src={fieldViolet} alt="" />;
            case 'polish-literature':
                return <img src={fieldRed} alt="" />;
            case 'foreign-literature':
                return <img src={fieldYellow} alt="" />;
            case 'movie-theatre-rtv':
                return <img src={fieldGreen} alt="" />;
            default:
                return;
        }
    };

    getSeparatorColor = (label) => {
        switch (label) {
            case 'literature-theory':
                return <div className="headings-structure__list-item--separator"></div>;
            case 'polish-literature':
                return <div className="headings-structure__list-item--separator red"></div>;
            case 'foreign-literature':
                return <div className="headings-structure__list-item--separator yellow"></div>;
            case 'movie-theatre-rtv':
                return <div className="headings-structure__list-item--separator green"></div>;
            default:
                return;
      }
    }

    render() {
        const {structureHeight, isOpened} = this.state;
        const {description, domainCode, recordsNumber, clang, children, getFieldChildren, isLoading, isError} = this.props;

        return (
          <li className="headings-structure__list-item" id={domainCode}>
              <h5 className="headings-structure__list-item--title">
                  {this.getImgField(domainCode)}
                  <span>{lang[clang].characteristics.heading}:
                  <strong> {lang[clang].characteristics[domainCode]}</strong></span>
              </h5>
              {this.getSeparatorColor(domainCode)}
              <p className="headings-structure__list-item--desc">
                  {description}
              </p>
              <div className="structure">
                  <div className="structure__box--left">
                      {this.getImgField(domainCode)}
                      <span className="structure__box--left-text">{lang[clang].characteristics.heading_structure}:</span>
                      <strong className="structure__box--left-field"> {lang[clang].characteristics[domainCode]}</strong>
                      <span className="structure__box--left-number"> ({!!recordsNumber ? numberWithSpaces(recordsNumber) : recordsNumber})</span>
                  </div>
                  {!isLoading && !isError && children && children.length > 0 &&
                    <div className="structure__box--right">
                        <button className="structure__toggle-button"
                        title={!isOpened ? lang[clang].characteristics.show_structure : lang[clang].characteristics.hide_structure}
                        onClick={() => this.toggleOpened()}>
                            {!isOpened && <span>{lang[clang].characteristics.show_structure}</span>}
                            {isOpened && <span>{lang[clang].characteristics.hide_structure}</span>}
                            {!isOpened && <img className="structure__toggle-button__img" src={chevronDown} alt="" />}
                            {isOpened && <img className="structure__toggle-button__img" src={chevronUp} alt="" />}
                        </button>
                    </div>}
              </div>
              {isOpened && !isLoading && isError &&
                  <div className="structure__error">{lang[clang].characteristics.error}</div>}
              {isOpened && isLoading && !isError &&
                  <LoadingIndicator />}
              {!isLoading && !isError && children && children.length > 0 &&
                  <ReactHeight onHeightReady={height => this.setStructureListHeight(height)}
                      ref={(list) => { this.structureList = list; }} className={`${!isOpened ? 'hidden' : ''}`}>
                      <ul className="structure__list">
                          {children.map((child, index) => child.expansible || (child.children && child.children.length > 0)?
                              <StrucutreListItem key={index} {...child}
                                  setOpened
                                  getFieldChildren={getFieldChildren}
                                  setStructureListHeight={this.setStructureListHeight}/>
                              : <StrucutreListItemSingle key={index} {...child} setStructureListHeight={this.setStructureListHeight}/>)}
                      </ul>
                  </ReactHeight>}
              {isOpened && structureHeight > 700 &&
                  <div className="structure__box--bottom">
                      <button className="structure__toggle-button" onClick={() => this.toggleOpened()} >
                          <span>{lang[clang].characteristics.hide_structure}</span>
                          <img className="structure__toggle-button__img" src={chevronUp} alt="" />
                      </button>
                  </div>}
          </li>
        );
    };
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage,
});

export default withRouter(connect(mapStateToProps)(HeadingsStrucutreListItem));



// WEBPACK FOOTER //
// ./src/components/characteristics/HeadingsStrucutreListItem.js